var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('writer-profile',{attrs:{"user-id":_vm.currentUser.id}})}
var staticRenderFns = []

export { render, staticRenderFns }